import React from 'react'

export const FormControlButton = ({
  children,
  className,
  style,
  onClick,
  disabled,
  ...props
}) => {
  return <a
    className={`form-control ${className || ''} form-control-button`}
    onClick={onClick}
    {...(disabled ? {readOnly: true} : {})}
    style={{
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      ...style
    }}
  >{children}
  </a>
}

const overflowEllipsis = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

FormControlButton.WithIcon = ({ side = "right", iconClass, onIconClick, children, ...props }) => {
  return <FormControlButton {...props}>
    <IconToTheSide
      icon={
        <span className={iconClass} onClick={(e) => {
          if (onIconClick) {
            e.stopPropagation();
            onIconClick()
          }
        }}></span>
      }
      side={side}>
      {children}
    </IconToTheSide>
  </FormControlButton>
}

FormControlButton.IconRight = ({...props}) => <FormControlButton.WithIcon side="right" {...props} />
FormControlButton.IconLeft = ({...props}) => <FormControlButton.WithIcon side="left" {...props} />

export const IconToTheSide = ({
  children,
  icon = <i className="fas fa-coffee"></i>,
  side = "left",
  style,
  className,
  ...props}) => {
  return <div
    {...props}
    className={`d-flex w-100 d-flex align-items-center ${className}`}
    style={{ ...overflowEllipsis, ...style}}>
      {side === "left" && <span className="content-spacer-right">{icon}</span>}
      {children}
      {side === "right" && <span className="ml-auto"><span className="content-spacer-left">{icon}</span></span>}
    </div>
}


